import { useEffect, useMemo, useState } from "react";
import NotEnoughSpaceModal from "components/Reusable/SaveMail/NotEnoughSpaceModal.js";
import SaveMail from "components/Reusable/SaveMail/SaveMail.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import NotSubscriberModal from "components/Reusable/NotSubscriberModal/NotSubscriberModal.js";

export const useSaveUploadingMail = () => {
  const { setModal, closeModal } = useModal();
  const { getSize, setSaved, getSaved } = useUploader();
  const { isSubscribed, getUserData } = useUser();
  const [loading, setLoading] = useState(false);

  const sizeLimit = useMemo(() => {
    if (!getUserData()) return 0;
    return getUserData().UserMaxStorage - getUserData().UserUsedStorage;
  }, [getUserData()]);

  useEffect(() => {
    if (getUserData() && getSaved() === undefined)
      setSaved(getUserData().DefaultSaveMail);
  }, [getUserData()]);

  useEffect(() => {
    if (sizeLimit < getSize()) {
      setSaved(false);
    }
  }, [getSize(), sizeLimit]);

  const handleClick = () => {
    if (getSaved()) {
      setSaved(false);
      setLoading(false);
    } else {
      saveActionFunc();
    }
  };

  const saveActionFunc = async () => {
    if (sizeLimit < getSize()) {
      setModal({
        modal: isSubscribed() ? NotEnoughSpaceModal : NotSubscriberModal,
      });
      setLoading(false);
      return;
    }
    if (isSubscribed()) {
      setSaved(true);
      setLoading(false);
    } else {
      showSaveModal();
    }
  };

  const showSaveModal = () => {
    setModal({
      modal: SaveMail,
      modalSize: "full-modal",
      props: {
        isMailSender: false,
        subscribeOnly: true,
        closeElement: () => {
          setLoading(false);
          closeModal();
        },
      },
    });
  };

  return { handleClick, loading, saved: getSaved() };
};
